/**
 * <cart-reward-bar>
 *
 * Barin kendisi tamamen sunucuda (snippets/cart-reward-bar.liquid) ciziliyor.
 * Tema sepeti degistirdiginde (adet degisimi, sepete ekleme) cart-drawer.js
 * zaten #CartDrawer / .drawer__inner icerigini sunucudan yeniden cekiyor, yani
 * bar dogru degerle geri geliyor. Bu dosyanin isi o yolun DISINDA kalan tek
 * durumu kapatmak: bir uygulamanin (orn. otomatik hediye ekleme) sepeti tema
 * bilgisi olmadan degistirmesi.
 *
 * Yaklasim: drawer her acildiginda cart.js'ten guncel toplami bir kez oku,
 * sunucunun cizdigi toplamdan farkliysa temanin kendi "cart-drawer:refresh"
 * event'ini tetikle. Bar yeniden sunucudan gelir.
 *
 * Boylece para birimi formatlama mantigi JS'te TEKRARLANMIYOR - onceki surumde
 * Liquid ve JS ayri ayri formatliyordu ve Liquid tarafi hatalıydı
 * (Shopify'da olmayan `number_format` filtresi kullaniliyordu).
 */
if (!customElements.get("cart-reward-bar")) {
  customElements.define(
    "cart-reward-bar",
    class CartRewardBar extends HTMLElement {
      connectedCallback() {
        // Sunucunun bu barı cizerken kullandigi sepet toplami (kurus).
        this.renderedTotal = Number(this.dataset.cartTotal);
        this.syncing = false;
        this.handleDrawerOpen = this.handleDrawerOpen.bind(this);

        // cart-drawer.js toggleDrawerClasses() icinde document uzerine atiyor.
        document.addEventListener("cart-drawer-open", this.handleDrawerOpen);
      }

      disconnectedCallback() {
        document.removeEventListener("cart-drawer-open", this.handleDrawerOpen);
        this.controller?.abort();
      }

      async handleDrawerOpen() {
        // Sepet sayfasinda drawer yok; tetiklenecek bir sey de yok.
        if (this.syncing || !document.querySelector("cart-drawer")) return;
        if (!Number.isFinite(this.renderedTotal)) return;

        this.syncing = true;
        this.controller = new AbortController();

        try {
          const response = await fetch(
            `${window.Shopify.routes.root}cart.js`,
            { signal: this.controller.signal },
          );
          if (!response.ok) return;

          const cart = await response.json();
          if (cart.total_price === this.renderedTotal) return;

          // Sunucudan yeniden ciz. renderContents(state, false) cagrilir,
          // yani drawer acik/kapali durumu degismez.
          document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
        } catch (error) {
          // Sessizce gec: bar sunucudan gelen degerle zaten dogru duruyor,
          // sadece uygulama kaynakli degisiklik yansimamis olur.
          if (error.name !== "AbortError") {
            console.warn("cart-reward-bar: sepet senkronizasyonu basarisiz", error);
          }
        } finally {
          this.syncing = false;
        }
      }
    },
  );
}
